var render = function render(){var _vm=this,_c=_vm._self._c;return _c('gl-empty-state',{attrs:{"description":_vm.__('To widen your search, change or remove filters above.'),"title":_vm.__('No results found'),"illustration-name":"empty-search-md","data-testid":"issuable-empty-state"}})
}
var staticRenderFns = []

export { render, staticRenderFns }